import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "提示1",
  "use": "提示1-usage",
  "viewBox": "0 0 174.87 174.87",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 174.87 174.87\" id=\"提示1\"><defs><style>#提示1 .cls-1{fill:#ffad31;}</style></defs><path class=\"cls-1\" d=\"M99.9,12.63a87.44,87.44,0,1,0,87.44,87.43A87.41,87.41,0,0,0,99.9,12.63Zm-.33,107A11.38,11.38,0,0,1,88.1,108.26V55a11.42,11.42,0,0,1,22.84,0v53.23A11.36,11.36,0,0,1,99.57,119.63ZM99.9,130a13.23,13.23,0,1,1-13.22,13.23A13.21,13.21,0,0,1,99.9,130Z\" transform=\"translate(-12.46 -12.63)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol